import React from 'react';
import ProtectedRoute from '../routers/private.route';
import UserContextProvider from '../contexts/auth.context';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import {
    Login,
    Logout,
    Dashboard,
    UserAccounts,
    OrganizationAccounts,
    CreateUpdateUserAccount,
    CreateUpdateOrgAccount,
    CreateUpdateOrgUserAccount,
    PageNotFound
} from '../pages';

const Routers = function () {
    //TODO: set param for add edit user and org
    return (
        <UserContextProvider>
            <Router>
                <Switch>
                    <Route path="/login" component={Login} />
                    <Route path="/logout" component={Logout} />
                    <ProtectedRoute exact path="/" component={UserAccounts} />
                    <ProtectedRoute path="/dashboard" component={Dashboard} />
                    <ProtectedRoute path="/user-accounts" component={UserAccounts} />
                    <ProtectedRoute path="/organization-accounts" component={OrganizationAccounts} />
                    <ProtectedRoute path="/user/:id" component={CreateUpdateUserAccount} />
                    <ProtectedRoute exact path="/organisation/:id" component={CreateUpdateOrgAccount} />
                    <ProtectedRoute path="/organisation/user/:id" component={CreateUpdateOrgUserAccount} />
                    <Route path="*" component={PageNotFound} />
                </Switch>
            </Router>
        </UserContextProvider>
    );
};
export default Routers;
